/* tslint:disable */
/* eslint-disable */
/**
 * TurboClaim API
 * TurboClaim API for insurance claim management. Includes claims, documents, estimates, supplements, billing, and chat operations. Authentication is JWT-based bearer token. 
 *
 * The version of the OpenAPI document: 1.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * A pending email invite for a person who has not yet created a TurboClaim account.
 * @export
 * @interface ClaimPendingInvite
 */
export interface ClaimPendingInvite {
    /**
     * The ID of the claim_invite record (used for revoke)
     * @type {number}
     * @memberof ClaimPendingInvite
     */
    inviteId: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimPendingInvite
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimPendingInvite
     */
    accessLevel: ClaimPendingInviteAccessLevelEnum;
    /**
     * Claim modules hidden for this pending invite recipient.
     * @type {Array<string>}
     * @memberof ClaimPendingInvite
     */
    blockedModules?: Array<ClaimPendingInviteBlockedModulesEnum>;
    /**
     * 
     * @type {string}
     * @memberof ClaimPendingInvite
     */
    invitedByName?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof ClaimPendingInvite
     */
    expiresAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof ClaimPendingInvite
     */
    createdAt: Date;
}


/**
 * @export
 */
export const ClaimPendingInviteAccessLevelEnum = {
    Ro: 'ro',
    Rw: 'rw'
} as const;
export type ClaimPendingInviteAccessLevelEnum = typeof ClaimPendingInviteAccessLevelEnum[keyof typeof ClaimPendingInviteAccessLevelEnum];

/**
 * @export
 */
export const ClaimPendingInviteBlockedModulesEnum = {
    Comparisons: 'comparisons',
    Documents: 'documents',
    Photos: 'photos',
    Links: 'links',
    Tasks: 'tasks',
    Supplements: 'supplements',
    Forms: 'forms',
    Financials: 'financials',
    Emails: 'emails',
    Notes: 'notes'
} as const;
export type ClaimPendingInviteBlockedModulesEnum = typeof ClaimPendingInviteBlockedModulesEnum[keyof typeof ClaimPendingInviteBlockedModulesEnum];


/**
 * Check if a given object implements the ClaimPendingInvite interface.
 */
export function instanceOfClaimPendingInvite(value: object): value is ClaimPendingInvite {
    if (!('inviteId' in value) || value['inviteId'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('accessLevel' in value) || value['accessLevel'] === undefined) return false;
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    return true;
}

export function ClaimPendingInviteFromJSON(json: any): ClaimPendingInvite {
    return ClaimPendingInviteFromJSONTyped(json, false);
}

export function ClaimPendingInviteFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimPendingInvite {
    if (json == null) {
        return json;
    }
    return {
        
        'inviteId': json['inviteId'],
        'email': json['email'],
        'accessLevel': json['accessLevel'],
        'blockedModules': json['blockedModules'] == null ? undefined : json['blockedModules'],
        'invitedByName': json['invitedByName'] == null ? undefined : json['invitedByName'],
        'expiresAt': (new Date(json['expiresAt'])),
        'createdAt': (new Date(json['createdAt'])),
    };
}

export function ClaimPendingInviteToJSON(json: any): ClaimPendingInvite {
    return ClaimPendingInviteToJSONTyped(json, false);
}

export function ClaimPendingInviteToJSONTyped(value?: ClaimPendingInvite | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'inviteId': value['inviteId'],
        'email': value['email'],
        'accessLevel': value['accessLevel'],
        'blockedModules': value['blockedModules'],
        'invitedByName': value['invitedByName'],
        'expiresAt': ((value['expiresAt']).toISOString()),
        'createdAt': ((value['createdAt']).toISOString()),
    };
}

